import React from 'react';
import { CheckCircle, Download, MonitorSmartphone, Printer, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="bg-dark-900 text-white py-6 md:py-10 px-4 relative overflow-hidden" data-id="element-40">
      {/* Background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] md:w-[800px] md:h-[800px] bg-brand-500/20 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-41"></div>

      <div className="max-w-5xl mx-auto text-center z-10 relative" data-id="element-42">
        <h1 className="text-4xl md:text-[64px] font-black mb-4 md:mb-6 uppercase tracking-tight text-white leading-tight" data-id="element-43">
          MANUAL ACADÉMICO DE{' '}
          <span className="text-brand-400 font-['Plus_Jakarta_Sans',_sans-serif] block md:inline mt-1 md:mt-0" data-id="element-44">
            PROGRAMACIÓN
          </span>{' '}
          <span className="block md:inline text-2xl md:text-[64px] mt-1 md:mt-0" data-id="element-45">
            PARA DOCENTES
          </span>
        </h1>

        <div className="max-w-xl md:max-w-2xl mx-auto mb-6 relative px-4 md:px-0" data-id="element-46">
          <img src="https://cdn.magicpatterns.com/uploads/hxDZRhVTaAzmo7c9mspV1T/Diseno_sin_titulo_(11).png" alt="Manual Académico de Programación" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-47" />
          {/* Guarantee Badge */}
          <div className="absolute -bottom-2 -right-0 md:bottom-4 md:-right-8 bg-brand-500 text-white font-black p-2 md:p-3 rounded-full w-20 h-20 md:w-28 md:h-28 flex flex-col items-center justify-center transform rotate-12 shadow-xl border-2 md:border-4 border-dark-900" data-id="element-48">
            <ShieldCheck className="mb-0.5 md:mb-1 w-5 h-5 md:w-6 md:h-6" data-id="element-49" />
            <span className="text-center leading-tight text-[10px] md:text-xs" data-id="element-50">
              GARANTÍA
              <br data-id="element-51" />7 DÍAS
            </span>
          </div>
        </div>

        <h2 className="text-lg md:text-3xl font-bold mb-3 md:mb-4 text-gray-300 px-2" data-id="element-52">
          para docentes de Programación de secundaria y tecnicaturas
        </h2>

        <p className="text-sm md:text-xl font-medium mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed text-gray-400 px-2" data-id="element-53">
          Clases, actividades, diapositivas, evaluaciones, trabajos prácticos,
          teoría resumida y planificaciones: todo el material completo de
          Programación I, II, III y IV en un solo lugar.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-[10px] md:text-sm font-semibold px-2" data-id="element-54">
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-55">
            <Download className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-56" />
            <span data-id="element-57">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-58">
            <CheckCircle className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-59" />
            <span data-id="element-60">Acceso de por vida</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-61">
            <MonitorSmartphone className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-62" />
            <span data-id="element-63">PDF</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-64">
            <Printer className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-65" />
            <span data-id="element-66">Material imprimible</span>
          </div>
        </div>
      </div>
    </section>;
}